/* eslint-disable react/no-unknown-property */
import React, { useRef, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Grid, Typography } from '@material-ui/core'
import { setAudioData } from '../../../modules/audio/actions'
import hideBtnIcon from '../../../assetss/img/hideBtnIcon.svg'
import closeAudioIcon from '../../../assetss/img/closeAudioIcon.svg'
import c from 'classnames'
import './index.scss'

const PauseIcon = props => (
  <svg {...props} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M10 4H6V20H10V4Z' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
    <path d='M18 4H14V20H18V4Z' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
  </svg>
)

const PlayIcon = props => (
  <svg {...props} width='16' height='20' viewBox='0 0 16 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1 1L15 10L1 19V1Z' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
  </svg>
)

const formatTime = seconds => {
  return [Math.floor(seconds / 60), Math.floor(seconds % 60)]
    .map(x => x.toString())
    .map(x => (x.length === 1 ? `0${x}` : x))
    .join(':')
}

const ScrollPlayer = ({ activePlayer, activePlayerBootom }) => {
  const dispatch = useDispatch()
  const { audioState } = useSelector(({ audio }) => audio)
  const [currentTime, setCurrentTime] = useState(0)
  const [duration, setDuration] = useState(0)
  const audioRef = useRef(null)
  const { pathname } = useLocation()

  useEffect(() => {
    if (audioState?.status) {
      audioRef?.current?.play()
    } else {
      audioRef?.current?.pause()
    }
  }, [audioState])

  useEffect(() => {
    dispatch(setAudioData({ ...audioState, time: currentTime }))
  }, [currentTime])

  useEffect(() => {
    if (audioState?.newTime) {
      audioRef.current.currentTime = audioState?.newTime
      dispatch(setAudioData({ ...audioState, newTime: null }))
    }
  }, [audioState])

  const disabledPlayer = () => {
    dispatch(setAudioData({
      status: false,
      src: null,
      time: 0,
      newTime: null,
      duration: null,
      podcast: {},
      progress: 0,
      active: false,
    }))
  }

  const hiddenPlayer = () => dispatch(setAudioData({ ...audioState, active: true }))

  return (
    <Grid className={c('boxScrollPlayer', activePlayer && 'newBoxScrollPlayer', activePlayerBootom && 'newBoxScrollPlayerBootom', pathname !== '/' && 'newBoxScrollPlayerBootom', audioState?.active && 'boxScrollPlayerHidden')}>
      <Grid className='boxPlayer'>
        <Typography className='titleAudio'>{audioState?.podcast?.title}</Typography>
        <Grid className='timeAudioScrollMobile'>{formatTime(currentTime)} / {formatTime(duration)}</Grid>
        {audioState?.status ? (
          <button
            onClick={() => {
              dispatch(setAudioData({ ...audioState, status: false }))
            }}
            className='btnAudio'
          >
            <PauseIcon />
          </button>
        ) : (
          <button
            onClick={() => {
              dispatch(setAudioData({ ...audioState, status: true }))
            }}
            className='btnAudioPlay'
          >
            <PlayIcon />
          </button>
        )}
        <Grid className='rightBoxAudio'>
          <Grid className='actionsAudioBtn'>
            <span className='hideBtnAudio' onClick={hiddenPlayer}><img src={hideBtnIcon} /></span>
            <span className='closeAudioIcon' onClick={disabledPlayer}><img src={closeAudioIcon} /></span>
          </Grid>
          <Grid className='timeAudioScroll'>{formatTime(currentTime)} / {formatTime(duration)}</Grid>
        </Grid>
      </Grid>
      <audio
        onPlay={e => e?.target?.addEventListener('ended', () => dispatch(setAudioData({ ...audioState, status: false, newTime: null, progress: 0, time: 0 })))}
        onLoadedData={() => {
          setDuration(audioRef.current.duration)
        }}
        className='hidenAudio'
        src={audioState?.podcast?.podcast?.src}
        controls
        ref={audioRef}
        onTimeUpdate={() => {
          setCurrentTime(audioRef.current.currentTime)
        }}
      />
    </Grid>
  )
}

export default ScrollPlayer
